<template>
  <div class="model">
    <a-modal :title="priceOrStock==2?'批量改价':'批量库存'" :visible="popupVisible" width="750px" :footer="null"
             @cancel="handleCancel">
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                    :label-col="{ span: 4 }" :wrapper-col="{ span: 20}">
        <a-row>
          <a-form-model-item
            v-for="(item, index) in ruleForm.priceDateList"
            :key="index"
            :label-col="index === 0 ? { span: 4 } : {}"
            :wrapper-col="index === 0 ?{ span: 20}:{ span: 20, offset: 4 }"
            :label="index === 0 ? labelName : ''"
            :prop="'priceDateList.' + index + '.dateTime'"
            :rules="{ required: true, message: '请选择变价时段', trigger: 'change',}"
          >
            <a-range-picker name="buildTime" :disabledDate="(current)=>disabledDate(current,index)"
                            v-model="item.dateTime" style="margin-right: 8px"
                            @change="(dates, dateStrArr)=>onDateChange(dates, dateStrArr,index)"
                            format="YYYY-MM-DD"/>
            <a-icon v-if="ruleForm.priceDateList.length > 1"
                    class="dynamic-delete-button"
                    type="minus-circle-o"
                    :disabled="ruleForm.priceDateList.length === 1"
                    @click="removeDomain(item)"
            />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }">
            <a-button type="dashed" @click="addDomain">
              <a-icon type="plus"/>
              添加
            </a-button>
          </a-form-model-item>
        </a-row>
        <a-form-model-item label="适用星期" prop="week">
          <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全部</a-checkbox>
          <a-checkbox-group v-model="ruleForm.week" :options="plainOptions" @change="onCheckChange"/>
        </a-form-model-item>
        <a-row v-if="priceOrStock==2">
          <a-form-model-item label="同行价" style="margin-bottom: 0;" required>
            <a-row :gutter="20">
              <a-col :span="6">
                <a-select v-model="ruleForm.priceType" placeholder="请选择">
                  <a-select-option :value="1">批量设置为</a-select-option>
                  <a-select-option :value="2">批量加价</a-select-option>
                  <a-select-option :value="3">批量减价</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="mfAuditPrice">
                  <a-input v-model="ruleForm.mfAuditPrice" addon-after="元"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model-item>
          <a-form-model-item label="建议销售价" style="margin-bottom: 0;" required>
            <a-row :gutter="20">
              <a-col :span="6">
                <a-select v-model="ruleForm.priceType" placeholder="请选择">
                  <a-select-option :value="1">批量设置为</a-select-option>
                  <a-select-option :value="2">批量加价</a-select-option>
                  <a-select-option :value="3">批量减价</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="advicePrice">
                  <a-input v-model="ruleForm.advicePrice" addon-after="元"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model-item>
          <a-form-model-item label="分销佣金" style="margin-bottom: 0;">
            <a-row :gutter="20">
              <a-col :span="6">
                <a-select v-model="ruleForm.priceType" placeholder="请选择">
                  <a-select-option :value="1">批量设置为</a-select-option>
                  <a-select-option :value="2">批量加价</a-select-option>
                  <a-select-option :value="3">批量减价</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="commissionPrice">
                  <a-input v-model="ruleForm.commissionPrice" addon-after="元"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model-item>
          <a-form-model-item label="市场价" style="margin-bottom: 0;" required>
            <a-row :gutter="20">
              <a-col :span="6">
                <a-select v-model="ruleForm.priceType" placeholder="请选择">
                  <a-select-option :value="1">批量设置为</a-select-option>
                  <a-select-option :value="2">批量加价</a-select-option>
                  <a-select-option :value="3">批量减价</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="marketPrice">
                  <a-input v-model="ruleForm.marketPrice" addon-after="元"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model-item>
          <a-form-model-item label="采购价" style="margin-bottom: 0;">
            <a-row :gutter="20">
              <a-col :span="6">
                <a-select v-model="ruleForm.priceType" placeholder="请选择">
                  <a-select-option :value="1">批量设置为</a-select-option>
                  <a-select-option :value="2">批量加价</a-select-option>
                  <a-select-option :value="3">批量减价</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="purchasePrice">
                  <a-input v-model="ruleForm.purchasePrice" addon-after="元"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model-item>
        </a-row>
        <a-row v-else>
          <a-form-model-item label="库存" style="margin-bottom: 0;">
            <a-row :gutter="20">
              <a-col :span="6">
                <a-select v-model="ruleForm.stockType" placeholder="请选择">
                  <a-select-option :value="1">批量设置为</a-select-option>
                  <a-select-option :value="2">批量加库存</a-select-option>
                  <a-select-option :value="3">批量减库存</a-select-option>
                </a-select>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="stock">
                  <a-input v-model="ruleForm.stock" placeholder="请输入库存"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model-item>
        </a-row>
        <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
          <a-button @click="handleCancel">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'HotelBatchChange',
  props: {
    priceOrStock: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    },
    selectedRowsIdList: {
      type: Array,
      default: () => [] //数组的默认值，必须这样写
    }
  },
  data() {
    return {
      ruleForm: {
        productId: this.$route.query.proId,
        priceDateList: [
          {
            dateTime: undefined,
            startTime: '',
            endTime: ''
          }
        ],
        startEndDate: '',
        priceType: 1,
        stockType: 1,
        advicePrice: '',
        mfAuditPrice: '',
        commissionPrice: '',
        purchasePrice: '',
        marketPrice: '',
        week: [],
        operation: '',
        optionPlanIds: []
      },
      rules: {
        mfAuditPrice: [
          { required: true, message: '请输入同行价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
        ],
        advicePrice: [
          { required: true, message: '请输入建议销售价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          },
          { validator: this.checkAdvicePrice, trigger: 'blur' }
        ],
        marketPrice: [
          { required: true, message: '请输入市场价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
        ],
        purchasePrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        commissionPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: this.checkCommissionPrice, trigger: 'blur' }
        ],
        stock: [
          { required: true, message: '请输入库存', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,5}$/, message: '请输入正确的库存', trigger: 'blur' }
        ]
      },
      plainOptions: [{ label: '周一', value: 1 }, { label: '周二', value: 2 }, {
        label: '周三',
        value: 3
      }, { label: '周四', value: 4 },
        { label: '周五', value: 5 }, { label: '周六', value: 6 }, { label: '周日', value: 7 }
      ],
      indeterminate: false,
      checkAll: false,
      checkedIdList: [1, 2, 3, 4, 5, 6, 7],
      popupVisible: false,
      submitLoading: false,
      labelName: '变价时段'
    }
  },
  watch: {
    visible(val) {
      this.popupVisible = val
    },
    priceOrStock(val) {
      this.labelName = val == 2 ? '变价时段' : '改库存时段'
      this.updateData()
    }
  },
  mounted() {
    this.popupVisible = this.visible
  },
  methods: {
    //更新数据
    updateData() {
      this.ruleForm = {
        productId: this.$route.query.proId,
        priceDateList: [
          {
            dateTime: undefined,
            startTime: '',
            endTime: ''
          }
        ],
        startEndDate: '',
        priceType: 1,
        stockType: 1,
        advicePrice: '',
        mfAuditPrice: '',
        commissionPrice: '',
        purchasePrice: '',
        marketPrice: '',
        week: [],
        operation: '',
        optionPlanIds: []
      }
      this.indeterminate = false
      this.checkAll = false
      this.checkedIdList = [1, 2, 3, 4, 5, 6, 7]
    },
    checkAdvicePrice(rule, value, callback) {
      if ((Number(value) < Number(this.ruleForm.mfAuditPrice)) && this.ruleForm.priceType == 1) {
        callback(new Error('销售价大于或等于同行价'))
      } else {
        callback()
      }
    },
    checkCommissionPrice(rule, value, callback) {
      if (this.ruleForm.priceType == 1 && (Math.round(Math.round(Number(this.ruleForm.advicePrice) * 100) - Math.round(Number(this.ruleForm.mfAuditPrice) * 100) - Math.round(Number(value) * 100)) / 100 < 0)) {
        callback(new Error('必须小于销售价减同行价'))
      } else {
        callback()
      }
    },
    disabledDate(current, index) {
      // Can not select days before today and today
      if (this.ruleForm.priceDateList.length > 1) {
        let length = this.ruleForm.priceDateList.length
        this.getLogUtils().logWithTag('disabledDate', this.ruleForm.priceDateList[length - 1].endTime)
        return current && current < moment().startOf('day') || current < moment(this.ruleForm.priceDateList[length - 1].endTime).endOf('day') || index > 0 && current < moment(this.ruleForm.priceDateList[index - 1].endTime).endOf('day')
      } else {
        return current && current < moment().startOf('day')
      }
    },
    //删除时间段
    removeDomain(item) {
      let index = this.ruleForm.priceDateList.indexOf(item)
      if (index !== -1) {
        this.ruleForm.priceDateList.splice(index, 1)
      }
    },
    //新增时间段
    addDomain() {
      if (this.ruleForm.priceDateList.length < 5) {
        this.ruleForm.priceDateList.push({
          dateTime: undefined,
          startTime: '',
          endTime: ''
        })
      } else {
        this.$message.error('最多新增5个变价时段')
      }
    },
    //变价时段
    onDateChange(dates, dateStrArr, index) {
      this.getLogUtils().logWithTag('onDateChange', dates)
      this.getLogUtils().logWithTag('onDateChange', dateStrArr)
      this.getLogUtils().logWithTag('index', index)
      this.ruleForm.priceDateList[index].dateTime = dates
      this.ruleForm.priceDateList[index].startTime = dateStrArr[0]
      this.ruleForm.priceDateList[index].endTime = dateStrArr[1]
      this.getLogUtils().logWithTag('onDateChange', this.ruleForm.priceDateList)
    },
    onCheckChange(checkedList) {
      this.getLogUtils().logWithTag('onChange===', checkedList)
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    onCheckAllChange(e) {
      this.getLogUtils().logWithTag('onCheckAllChange===', e)
      this.ruleForm.week = e.target.checked ? this.checkedIdList : []
      this.checkAll = e.target.checked
      this.indeterminate = false
      this.getLogUtils().logWithTag('数据===', this.ruleForm.week)
    },
    handleCancel() {
      this.$emit('changeClose')
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      let dateStr = this.submitFormData.priceDateList.map(item => {
        return item.startTime + ',' + item.endTime
      }).join('|')
      this.getLogUtils().logWithTag('价格集合', dateStr)
      this.submitFormData.startEndDate = dateStr
      let weekStr = this.submitFormData.week && this.submitFormData.week.length > 0 ? this.submitFormData.week.join(',') : '1,2,3,4,5,6,7'
      this.submitFormData.week = weekStr
      this.submitFormData.operation = this.priceOrStock == 2 ? 1 : 2
      let text = this.priceOrStock == 2 ? '改价' : '库存'
      this.submitFormData.optionPlanIds = this.selectedRowsIdList
      delete this.submitFormData.priceDateList
      this.getHttpServices().getProService().post('api/v2/productManage/hotel/price-plan/batch/price', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('批量' + text + '保存成功')
        this.handleCancel()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    }
  }

}
</script>
<style lang="less" scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>